import { render, staticRenderFns } from "./ThgProcessDescriptionCard.vue?vue&type=template&id=2488963a&scoped=true&"
import script from "./ThgProcessDescriptionCard.vue?vue&type=script&lang=ts&"
export * from "./ThgProcessDescriptionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2488963a",
  null
  
)

export default component.exports